import { useEffect, useRef } from "react";
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min";
import "./SidePanel.scss";

function SidePanelContainer({
  title = "Menu",
  children,
  openModule,
  setOpenModule,
  width = "500px",
}) {
  const offcanvasRef = useRef(null);
  let offcanvasInstance = useRef(null);

  const handleClose = () => {
    setOpenModule(false);
  };

  const openPanel = () => {
    offcanvasInstance.current.show();
  };

  useEffect(() => {
    offcanvasInstance.current = new bootstrap.Offcanvas(offcanvasRef.current);

    offcanvasRef.current?.addEventListener("hidden.bs.offcanvas", handleClose);

    return () => {
      offcanvasRef.current?.removeEventListener(
        "hidden.bs.offcanvas",
        handleClose,
      );

      offcanvasInstance.current?.dispose();
    };
  }, []);

  useEffect(() => {
    if (openModule) {
      openPanel();
    } else {
      return () => {
        // 1. Remove the active styles that freeze the page
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";

        // 2. Clean up the "memory" attributes (optional but cleaner)
        document.body.removeAttribute("data-bs-overflow");
        document.body.removeAttribute("data-bs-padding-right");

        // 3. Remove the gray backdrop if it got stuck
        const backdrop = document.querySelector(".offcanvas-backdrop");
        if (backdrop) backdrop.remove();
      };
    }
  }, [openModule]);

  return (
    <div>
      <div
        ref={offcanvasRef}
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        style={{
          "--bs-offcanvas-width": width,
        }}
      >
        {/* Header */}
        <div className="offcanvas-header border-bottom">
          <h5 className="offcanvas-title">{title}</h5>

          <button className="btn-close" data-bs-dismiss="offcanvas" />
        </div>

        {/* Body */}
        <div className="offcanvas-body">{children}</div>
      </div>
    </div>
  );
}

export default SidePanelContainer;
